module.exports = __webpack_public_path__ + "static/media/iconActivityActive.c54d96d0.svg";